export default "__VITE_ASSET__9atWkNoV__"